module.exports = __webpack_public_path__ + "img/image-slash.21f25887.svg";